import { Injectable } from '@angular/core'
import { collection, collectionData, doc, Firestore, updateDoc } from '@angular/fire/firestore'
import { Observable } from 'rxjs'
import { shareReplay } from 'rxjs/operators'
import { Trainer } from 'src/domain/dog'

@Injectable({ providedIn: 'root' })
export class TrainersService {
  private cachedTrainers: Observable<Trainer[]>

  constructor(private store: Firestore) {
    this.cachedTrainers = collectionData(collection(this.store, 'trainers')).pipe(shareReplay(1)) as Observable<Trainer[]>
  }

  get trainers(): Observable<Trainer[]> {
    return this.cachedTrainers
  }

  getTrainerDoc(trainerId: string) {
    return doc(this.store, 'trainers', trainerId)
  }

  removeTrainer(trainderId: string) {
    return updateDoc(this.getTrainerDoc(trainderId), {
      deletedAt: new Date()
    })
  }
}
